import axios from "../../../../../../utils/request"

function GET_DATA(params) {
    return axios.get("/ai/Assistant/info", {
        params: {
            ...params
        }
    } )
}


function SUBMIT_EDIT (params) {
    return  axios.post("/ai/Assistant/edit",{...params} )
}
export default {
    GET_DATA,
    SUBMIT_EDIT
}